import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const ProfileIllustration = ({ width = 45, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFBF00"
          d="M40 22.417c0-.448 0-.946-.05-1.395L45 17.685 37.5 4.732 32.4 8.12c-.8-.548-1.55-.996-2.4-1.395V0h-7.5v9c7.212 0 13.06 5.848 13.06 13.06 0 7.213-5.848 13.06-13.06 13.06V45H30v-6.891c.85-.398 1.6-.847 2.4-1.395l5.1 3.388L45 27.149l-5.05-3.337c.05-.45.05-.947.05-1.395"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M40 22.417c0-.448 0-.946-.05-1.395L45 17.685 37.5 4.732 32.4 8.12c-.8-.548-1.55-.996-2.4-1.395V0h-7.5v9.001c7.212 0 13.06 5.847 13.06 13.06 0 7.212-5.848 13.059-13.06 13.059V45H30v-6.891c.85-.398 1.6-.847 2.4-1.395l5.1 3.388L45 27.149l-5.05-3.337c.05-.449.05-.947.05-1.395"
        />
        <path
          fill="#FFBF00"
          d="M9.44 22.06C9.44 14.848 15.289 9 22.5 9V0H15v6.725c-.85.398-1.6.846-2.4 1.394L7.5 4.732 0 17.684l5.05 3.337c-.05.45-.05.947-.05 1.395 0 .45 0 .947.05 1.395L0 27.15l7.5 12.952 5.1-3.388c.8.55 1.55.996 2.4 1.395V45h7.5v-9.88c-7.212 0-13.06-5.847-13.06-13.06"
        />
        <path
          fill="#94C9E2"
          d="M22.5 30.613c-6.287 0-7.067-1.752-7.067-1.752 0-3.242 2.187-5.97 5.168-6.8l1.898 1.9M22.5 23.96l1.9-1.9c2.978.83 5.166 3.559 5.166 6.8 0 0-.78 1.754-7.066 1.754V23.96zM22.5 21.1c-2.127 0-3.853-1.724-3.853-3.851s1.726-3.851 3.853-3.851M22.5 13.398c2.128 0 3.852 1.724 3.852 3.852 0 2.127-1.724 3.85-3.852 3.85v-7.702z"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M22.5 23.96l1.9-1.9c2.978.83 5.166 3.559 5.166 6.8 0 0-.78 1.754-7.066 1.754V23.96zM22.5 13.398c2.128 0 3.852 1.724 3.852 3.852 0 2.127-1.724 3.85-3.852 3.85v-7.702z"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
